import { render, staticRenderFns } from "./PointDetail.vue?vue&type=template&id=75b91b3c&scoped=true"
import script from "./PointDetail.vue?vue&type=script&lang=js"
export * from "./PointDetail.vue?vue&type=script&lang=js"
import style0 from "./PointDetail.vue?vue&type=style&index=0&id=75b91b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b91b3c",
  null
  
)

export default component.exports